import type { SynthesisSessionRepository } from "../repositories/synthesis-session-repository"

export const makeListSynthesisSessions = (
  repo: SynthesisSessionRepository,
) => () => repo.list()
